import { auth } from "../firebase";
import { AuthUser, Pass } from "../model/Auth";
import { Result } from "../model/Result";
import jwtApi from "./Jwt.api";

import axiosCilent from "./axiosClient";

//スタッフ系は Firebase auth に登録するため authApi
const authApi = {
  requestCreateStaff: async ( staff: AuthUser & Pass, tenantId: string )
    : Promise<Result> => {
    try {
      const currentUser = auth.currentUser;
      return await jwtApi.requestGetJwt(currentUser?.email!, currentUser?.uid!, currentUser?.tenantId!)
        .then(async (_) => {
          const response = await axiosCilent.post(`createStaff/${tenantId}`, staff);
          return response.data;
        })
        .catch((rejects) => {
          return {success: false, data: rejects};
        });
    } catch (error) {
      return {success: false, data: error};
    }
  },
  requestUpdateStaff: async ( staff: AuthUser & Pass, tenantId: string )
    : Promise<Result> => {
    try {
      const currentUser = auth.currentUser;
      return await jwtApi.requestGetJwt(currentUser?.email!, currentUser?.uid!, currentUser?.tenantId!)
        .then(async (_) => {
          const response = await axiosCilent.post(`updateStaff/${tenantId}`, staff);
          return response.data;
        })
        .catch((rejects) => {
          return {success: false, data: rejects};
        });
    } catch (error) {
      return {success: false, data: error};
    }
  },
  requestDeleteStaff: async( staff: AuthUser, tenantId: string )
    : Promise<Result> => {
    try {
      const currentUser = auth.currentUser;
      return await jwtApi.requestGetJwt(currentUser?.email!, currentUser?.uid!, currentUser?.tenantId!)
        .then(async (_) => {
          const response = await axiosCilent.post(`deleteStaff/${tenantId}`, staff);
          return response.data;
        })
        .catch((rejects) => {
          return {success: false, data: rejects};
        });
    } catch (error) {
      return {success: false, data: error};
    }
  },
  requestGetStaff: async (tenantId: string)
    : Promise<Result> => {
    try {
      const response = await axiosCilent.post(
        `getStaffList/${tenantId}`, {}, {
          timeout: 0
        });
          return response.data;
    } catch (error) {
      return {success: false, data: error};
    }
  },

  requestTenantSendEmail: async (tenantId: string, email: string)
    : Promise<Result> => {
    try {
      const currentUser = auth.currentUser;
      return await jwtApi.requestGetJwt(currentUser?.email!, currentUser?.uid!, currentUser?.tenantId!)
        .then(async (jwt) => {
          const response = await axiosCilent.post(`tenantSendEmail/${tenantId}`, {email},
          {
            headers: {
              'Authorization': jwt.data
            }
          });
          return response.data;
        })
        .catch((rejects) => {
          return {success: false, data: rejects};
        });
    } catch (error) {
      return {success: false, data: error};
    }
  },
  requestIpAddressCheck: async (tenantId: string)
  : Promise<Result> => {
    try {
      const response = await axiosCilent.post(`ipaddressCheck/${tenantId}`);
      return response.data;
    } catch (error) {
      return {success: false, data: error};
    }
  },
  requestSendEmailGeneral: async (text: string, subject: string, toAddress: string | string[])
    : Promise<Result> => {
    try {
      const currentUser = auth.currentUser;
      return await jwtApi.requestGetJwt(currentUser?.email!, currentUser?.uid!, currentUser?.tenantId!)
        .then(async (jwt) => {
          const response = await axiosCilent.post(`sendEmailGeneral/${text}/${subject}`, {toAddress},
          {
            headers: {
              'Authorization': jwt.data
            }
          });
          return response.data;
        })
        .catch((rejects) => {
          return {success: false, data: rejects};
        });
    } catch (error) {
      return {success: false, data: error};
    }
  },
  requestAllAdminSendEmail: async (text: string, subject: string)
    : Promise<Result> => {
    try {
      const currentUser = auth.currentUser;
      return await jwtApi.requestGetJwt(currentUser?.email!, currentUser?.uid!, currentUser?.tenantId!)
        .then(async (_) => {
          const response = await axiosCilent.post(`allAdminSendEmail/${text}/${subject}`);
          return response.data;
        })
        .catch((rejects) => {
          return {success: false, data: rejects};
        });
    } catch (error) {
      return {success: false, data: error};
    }
  },
  requestTenantSendPasswordResetEmail: async (tenantId: string, email: string)
    : Promise<Result> => {
    try {
      const response = await axiosCilent.post(`tenantSendPasswordResetEmail/${tenantId}`, {email});
      return response.data;
    } catch (error) {
      return {success: false, data: error};
    }
  },
  /**
   * 団体スタッフ情報を取得する
   * 
   * @param tenantId 
   * @param userId 
   * @returns 
   */
  requestGetStaffInfo: async (tenantId: string, userId: string) : Promise<Result> => {
    try {
      const requestData = { userId: userId };
      const response = await axiosCilent.post(`getStaffInfo/${tenantId}`, requestData);
      return response.data;

    } catch (error) {
      return {success: false, data: error};
    }
  },
};

export default authApi;
